(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AvmOrderResultsController', AvmOrderResultsController);

    AvmOrderResultsController.$inject = ['$state', '$uibModal', 'AvmOrderResults', 'ParseLinks', 'AlertService', 'FileSaver', 'moment', 'pagingParams'];

    function AvmOrderResultsController ($state, $uibModal, AvmOrderResults, ParseLinks, AlertService, FileSaver, moment, pagingParams) {
        var vm = this;
        var defaultSort = 'createdDate,desc';

        vm.pagingParams = pagingParams;
        vm.results = null;
        vm.links = null;
        vm.totalItems = null;
        vm.fromDate = moment().subtract(1, 'month').toDate();
        vm.toDate = moment().toDate();
        vm.status = null;           // null = all statuses
        vm.requestType = null;      // null = all request types
        vm.profile = null;          // null = all profiles
        vm.appraisalOrderId = null; // the natural handle for a single order's attempts

        vm.statuses = [
            { value: null, label: 'All Statuses' },
            { value: 'COMPLETE', label: 'Complete' },
            { value: 'FAILED', label: 'Failed' },
            { value: 'PENDING', label: 'Pending' }
        ];
        vm.requestTypes = [
            { value: null, label: 'All Request Types' },
            { value: 'AVM', label: 'AVM Only' },
            { value: 'MARKET_RENT', label: 'Market Rent Only' },
            { value: 'AVM_AND_MARKET_RENT', label: 'AVM and Market Rent' }
        ];
        vm.profiles = [
            { value: null, label: 'All Profiles' },
            { value: 'ENRICHED', label: 'Enriched' },
            { value: 'ESSENTIALS', label: 'Essentials' },
            { value: 'ADJUSTED', label: 'Adjusted' }
        ];

        vm.loadData = loadData;
        vm.transition = transition;
        vm.applyFilters = applyFilters;
        vm.exportCsv = exportCsv;
        vm.viewRequest = viewRequest;
        vm.viewClientRequest = viewClientRequest;
        vm.viewClientResponse = viewClientResponse;
        vm.viewUpstreamRequest = viewUpstreamRequest;
        vm.viewRawResponse = viewRawResponse;
        vm.statusClass = statusClass;

        loadData();

        function buildParams() {
            return {
                page: vm.pagingParams.page - 1,
                size: 20,
                sort: getSort(),
                from: moment(vm.fromDate).startOf('day').toISOString(),
                to: moment(vm.toDate).endOf('day').toISOString(),
                status: vm.status || undefined,
                requestType: vm.requestType || undefined,
                profile: vm.profile || undefined,
                appraisalOrderId: vm.appraisalOrderId || undefined
            };
        }

        function loadData() {
            return AvmOrderResults.query(buildParams(), function(result, headers) {
                vm.results = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            }, function(error) {
                AlertService.error(error.data && error.data.message);
            }).$promise;
        }

        function getSort() {
            return vm.pagingParams.predicate + ',' + (vm.pagingParams.ascending ? 'asc' : 'desc');
        }

        function transition() {
            $state.go($state.$current, {
                page: vm.pagingParams.page === 1 ? null : vm.pagingParams.page,
                sort: getSort() === defaultSort ? null : getSort()
            }, { notify: false }).then(loadData);
        }

        /**
         * Apply a filter change: jump back to the first page, then reload.
         */
        function applyFilters() {
            vm.pagingParams.page = 1;
            transition();
        }

        /**
         * Download a CSV of the current (filtered) result set. An over-cap export comes back as a 400 with
         * the message in a header, which the global error interceptor surfaces as an alert.
         */
        function exportCsv() {
            var params = buildParams();
            delete params.page;
            delete params.size;
            delete params.sort;
            return AvmOrderResults.export(params).$promise.then(function(response) {
                if (response && response.file) {
                    FileSaver.saveAs(response.file, 'avm-order-results.csv');
                }
            });
        }

        /**
         * Open a modal showing the first-party request we sent for this call — internal tracing.
         */
        function viewRequest(result) {
            openDetail(result, 'request');
        }

        /**
         * Open a modal showing the request the client posted to pre-flight, exactly as it arrived — the
         * only body that shows fields we dropped on the way in.
         */
        function viewClientRequest(result) {
            openDetail(result, 'client-request');
        }

        /** Open a modal showing the answer the client received. */
        function viewClientResponse(result) {
            openDetail(result, 'client-response');
        }

        /**
         * Open a modal showing the payload we actually sent Gnowise — the translated body, not the node
         * above it, which is the distinction a vendor escalation turns on.
         */
        function viewUpstreamRequest(result) {
            openDetail(result, 'upstream-request');
        }

        /**
         * Open a modal showing the raw Gnowise response — internal, for vendor escalation.
         */
        function viewRawResponse(result) {
            openDetail(result, 'raw-response');
        }

        function openDetail(result, mode) {
            $uibModal.open({
                templateUrl: 'app/admin/avm-order-results/avm-order-result-detail-dialog.html',
                controller: 'AvmOrderResultDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: ['AvmOrderResults', function(AvmOrderResults) {
                        if (mode === 'request') {
                            return AvmOrderResults.getRequestJson({ id: result.id }).$promise;
                        }
                        if (mode === 'client-request') {
                            return AvmOrderResults.getClientRequestBody({ id: result.id }).$promise;
                        }
                        if (mode === 'client-response') {
                            return AvmOrderResults.getClientResponseBody({ id: result.id }).$promise;
                        }
                        if (mode === 'upstream-request') {
                            return AvmOrderResults.getUpstreamRequest({ id: result.id }).$promise;
                        }
                        return AvmOrderResults.getRawResponse({ id: result.id }).$promise;
                    }],
                    result: function() {
                        return result;
                    },
                    mode: function() {
                        return mode;
                    }
                }
            });
        }

        function statusClass(status) {
            if (status === 'COMPLETE') {
                return 'label label-success';
            }
            if (status === 'FAILED') {
                return 'label label-danger';
            }
            return 'label label-warning';
        }
    }
})();
